export const ZERO_LEVEL_PADDING = 27;
export const REGULAR_PADDING = 38;
